module.exports = __webpack_public_path__ + "static/media/wcs.d61e02be.png";